import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FaArrowLeft, FaCalendar, FaClock, FaMapMarkerAlt, FaBuilding, FaCog, FaExclamationTriangle, FaUser } from 'react-icons/fa';
import './Preview.css';
import Logo from "../assets/logoapp.png";
import { apiGet } from '../services/api';

function Preview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [registro, setRegistro] = useState(null);
  const [unidade, setUnidade] = useState('');
  const [local, setLocal] = useState('');
  const [processo, setProcesso] = useState('');
  const [tipoRegistro, setTipoRegistro] = useState('');
  const [potencial, setPotencial] = useState('');
  const [envolvido, setEnvolvido] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }
    fetchRegistro();
  }, [id, navigate]);

  const fetchRegistro = async () => {
    setIsLoading(true);
    try {
      // Buscar o registro específico
      const { data } = await apiGet(`/registros/${id}`);

      if (data.status === 'success' && data.data) {
        setRegistro(data.data);
        
        // Buscar dados complementares
        await Promise.all([
          fetchUnidade(data.data.unidades_id),
          fetchLocal(data.data.locais_id),
          fetchProcesso(data.data.processos_id),
          fetchTipoRegistro(data.data.tipo_registro_id),
          fetchPotencial(data.data.potencial_fa_id),
          fetchEnvolvido(data.data.tipo_envolvido_id),
        ]);
      }
    } catch (error) {
      console.error('Erro ao buscar registro:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUnidade = async (unidadeId) => {
    try {
      const { data } = await apiGet('/units');
      if (data.status === 'success') {
        const unit = data.data.find(u => u.id === unidadeId);
        setUnidade(unit ? unit.nome : 'Não informado');
      }
    } catch (error) {
      console.error('Erro ao buscar unidade:', error);
    }
  };

  const fetchLocal = async (localId) => {
    try {
      const { data } = await apiGet('/locais');
      if (data.status === 'success') {
        const loc = data.data.find(l => l.id === localId);
        setLocal(loc ? loc.nome : 'Não informado');
      }
    } catch (error) {
      console.error('Erro ao buscar local:', error);
    }
  };

  const fetchProcesso = async (processoId) => {
    try {
      const { data } = await apiGet('/processos');
      if (data.status === 'success') {
        const proc = data.data.find(p => p.id === processoId);
        setProcesso(proc ? proc.nome : 'Não informado');
      }
    } catch (error) {
      console.error('Erro ao buscar processo:', error);
    }
  };

  const fetchTipoRegistro = async (tipoId) => {
    try {
      const { data } = await apiGet('/tiporegistro');
      if (data.status === 'success') {
        const tipo = data.data.find(t => t.id === tipoId);
        setTipoRegistro(tipo ? tipo.nome : 'Não informado');
      }
    } catch (error) {
      console.error('Erro ao buscar tipo de registro:', error);
    }
  };

  const fetchPotencial = async (potencialId) => {
    try {
      const { data } = await apiGet('/potencial');
      if (data.status === 'success') {
        const pot = data.data.find(p => p.id === potencialId);
        setPotencial(pot ? pot.nome : 'Não informado');
      }
    } catch (error) {
      console.error('Erro ao buscar potencial:', error);
    }
  };

  const fetchEnvolvido = async (envolvidoId) => {
    try {
      const { data } = await apiGet('/tipoenvolvido');
      if (data.status === 'success') {
        const env = data.data.find(e => e.id === envolvidoId);
        setEnvolvido(env ? env.nome : 'Não informado');
      }
    } catch (error) {
      console.error('Erro ao buscar envolvido:', error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Não informado';
    const [ano, mes, dia] = dateString.split('-');
    const date = new Date(ano, mes - 1, dia);
    return date.toLocaleDateString('pt-BR');
  };

  const handleBack = () => {
    navigate('/home');
  };

  if (isLoading) {
    return (
      <div className="preview-container">
        <header className="preview-header">
          <img src={Logo} alt="Fique Atento" className="preview-logo" />
        </header>
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Carregando registro...</p>
        </div>
      </div>
    );
  }

  if (!registro) {
    return (
      <div className="preview-container">
        <header className="preview-header">
          <img src={Logo} alt="Fique Atento" className="preview-logo" />
        </header>
        <div className="preview-content">
          <div className="error-state">
            <p>Registro não encontrado.</p>
            <button onClick={handleBack} className="btn-back">
              <FaArrowLeft /> Voltar
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="preview-container">
      {/* Header */}
      <header className="preview-header">
        <img src={Logo} alt="Fique Atento" className="preview-logo" />
        <button onClick={handleBack} className="btn-back-header">
          <FaArrowLeft /> Voltar
        </button>
      </header>

      {/* Conteúdo */}
      <div className="preview-content">
        <div className="preview-card">
          <div className="preview-title-section">
            <h1>Detalhes do Registro</h1>
            <span className="registro-id">#{registro.id}</span>
          </div>

          {/* Informações principais */}
          <div className="preview-section">
            <h2 className="section-title">Informações do Evento</h2>
            
            <div className="info-grid">
              <div className="info-item">
                <div className="info-icon">
                  <FaCalendar />
                </div>
                <div className="info-content">
                  <span className="info-label">Data</span>
                  <span className="info-value">{formatDate(registro.datapoc)}</span>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <FaClock />
                </div>
                <div className="info-content">
                  <span className="info-label">Hora</span>
                  <span className="info-value">{registro.horafa || 'Não informado'}</span>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <FaBuilding />
                </div>
                <div className="info-content">
                  <span className="info-label">Unidade</span>
                  <span className="info-value">{unidade}</span>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <FaMapMarkerAlt />
                </div>
                <div className="info-content">
                  <span className="info-label">Local</span>
                  <span className="info-value">{local}</span>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <FaCog />
                </div>
                <div className="info-content">
                  <span className="info-label">Processo</span>
                  <span className="info-value">{processo}</span>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <FaExclamationTriangle />
                </div>
                <div className="info-content">
                  <span className="info-label">Classificação</span>
                  <span className="info-value">{tipoRegistro}</span>
                </div>
              </div>

              {potencial && potencial !== 'Não informado' && (
                <div className="info-item">
                  <div className="info-icon">
                    <FaExclamationTriangle />
                  </div>
                  <div className="info-content">
                    <span className="info-label">Potencial</span>
                    <span className="info-value">{potencial}</span>
                  </div>
                </div>
              )}

              <div className="info-item">
                <div className="info-icon">
                  <FaUser />
                </div>
                <div className="info-content">
                  <span className="info-label">Envolvido</span>
                  <span className="info-value">{envolvido}</span>
                </div>
              </div>

              {registro.terceiro && (
                <div className="info-item full-width">
                  <div className="info-icon">
                    <FaBuilding />
                  </div>
                  <div className="info-content">
                    <span className="info-label">Empresa Terceira</span>
                    <span className="info-value">{registro.terceiro}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Descrição do evento */}
          <div className="preview-section">
            <h2 className="section-title">Descrição do Evento</h2>
            <div className="description-box">
              <p>{registro.desc_evento || 'Não informado'}</p>
            </div>
          </div>

          {/* Ação realizada */}
          <div className="preview-section">
            <h2 className="section-title">Ação Realizada</h2>
            <div className="description-box">
              <p>{registro.acao_realizada || 'Não informado'}</p>
            </div>
          </div>

          {/* Botão voltar */}
          <div className="preview-actions">
            <button onClick={handleBack} className="btn-back-large">
              <FaArrowLeft /> Voltar para Meus Registros
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Preview;